import service from '@/utils/request'
import request from '@/utils/axios-v2'


function getDocumentParamsList() {
  return service({
    url: '/fleet/document/v2/web/param/list',
    method: 'get',
    headers: {
      'portal-token': true
    },
  })
}

function getDocumentList(data) {
  return service({
    data,
    url: '/fleet/document/v2/web/query/all',
    method: 'post',
    headers: {
      'portal-token': true
    },
  })
}

function getDocumentLoadList(data) {
  return service({
    data,
    url: '/fleet/document/v2/web/query/load',
    method: 'post',
    headers: {
      'portal-token': true
    },
  })
}


function getDocumentDriverList(data) {
  return service({
    data,
    url: '/fleet/document/v2/web/query/driver',
    method: 'post',
    headers: {
      'portal-token': true
    },
  })
}



function delDocumentById(data) {
  return service({
    url: '/fleet/document/v2/web/delete',
    method: 'put',
    params: data,
    headers: {
      'portal-token': true
    },
  })
}

function addDocument(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/zuul/document/add/document',
    method: 'post',
    data,
    isNotPrompt: true,
    headers: {
      'portal-token': true
    },
  })
}

function editDocumentName(data) {
  return service({
    url: '/fleet/document/v2/web/edit',
    method: 'put',
    params: data,
    headers: {
      'portal-token': true
    },
  })
}

function downloadDocument(data) {
  return service({
    url: '/fleet/document/v2/web/download/all',
    method: 'post',
    data,
    headers: {
      'portal-token': true
    },
  })
}

function emailDocument(data) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/zuul/document/email',
    method: 'POST',
    data,
    headers: {
      'portal-token': true
    },
  })
}

function downloadDocumentAll(data) {
  return service({
    url: '/fleet/document/v2/web/download/all',
    method: 'POST',
    data,
    headers: {
      'portal-token': true
    },
  })
}

function getAttributeList(data, fleetCompanyId) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/zuul/document/tag/query',
    method: 'get',
    params: {attribute: data,fleetCompanyId: fleetCompanyId},
    headers: {
      'portal-token': true
    },
  })
}



export {
  getDocumentParamsList,
  getDocumentList,
  delDocumentById,
  addDocument,
  getDocumentLoadList,
  editDocumentName,
  getDocumentDriverList,
  downloadDocument,
  emailDocument,
  downloadDocumentAll,
  getAttributeList
}
